import { ReactNode } from "react";

interface ArticleContentProps {
  children: ReactNode;
}

const BODY_CLASSES = [
  "px-8 py-6",
  // Section dividers
  "[&_section]:pt-10 [&_section]:pb-6 [&_section]:border-b [&_section]:border-secondary-bluegrey-3",
  "[&_section:first-of-type]:pt-0",
  "[&_section:last-of-type]:pb-0 [&_section:last-of-type]:border-b-0",
  // Prose typography (text + list bodies)
  "[&_p]:mb-6 [&_p]:text-base [&_p]:font-normal [&_p]:leading-relaxed [&_p]:text-primary-black [&_p]:break-words",
  "[&_ul]:mb-6 [&_ul]:text-base [&_ul]:font-normal [&_ul]:leading-relaxed [&_ul]:text-primary-black [&_ul]:break-words",
  "[&_ul]:flex [&_ul]:flex-col [&_ul]:gap-6 [&_ul]:p-0 [&_ul]:list-none",
  "[&_ul>li]:before:content-['•_'] [&_ul>li]:before:text-primary-black",
].join(" ");

export function ArticlePageBody({ children }: ArticleContentProps) {
  return <div className={BODY_CLASSES}>{children}</div>;
}
